import { connect } from 'react-redux'
import { themeSelector } from '../../../redux/theme/selector'
import { SingleCheckboxFieldClass } from './SingleCheckboxField.component'

const SingleCheckboxField = connect(themeSelector)(SingleCheckboxFieldClass)
export { SingleCheckboxField }
